import AuthApi from '@/services/AuthApi'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO_AUTH = '/auth'
const RECURSO_REFRESH = '/refresh'
const RECURSO_SAUDE = '/saude'

export default {
  login,
  refresh,
  saude,
}

function login (payload) {
  return AuthApi.post(RECURSO_AUTH, payload)
}

function refresh (token) {
  let data = {}
  let config = {
    headers: {
      Authorization: MetodosGlobais.montarToken(token),
    },
  }

  return AuthApi.post(RECURSO_REFRESH, data, config)
}

function saude () {
  return AuthApi.get(RECURSO_SAUDE)
}
